import { getField, updateField } from "vuex-map-fields";
import userGuideMotp from "./userGuideMotp";
import createMotp from "./createMotp";
import changeMotpPin from "./changeMotpPin";
import authPCMotp from "./authPCMotp";
import certnStupModfiMotp from "./certnStupModfiMotp";
import discardOrReportMotp from "./discardOrReportMotp";
import reregisterOtp from "./reregisterOtp";
import createFido from "./createFido";
import commMotpCertn from "./commMotpCertn";
import unlockAuthErrMotp from "./unlockAuthErrMotp";
import manageFido from "./manageFido";
let callNative = new Object();

const getDefaultState = () => {
  return {
    checkNativeMotp: false,
    /**
     * mOTP 존재 여부
     */
    mOtpExstYN: "N",
    /**
     * mOTP 기기정보
     */
    SSInfogetMotp: {
      in: {},
      out: [
        // {
        // 	strUserId: "G21000009100000"
        // , secret: "dfefewfsdfadsafasdfasdfsdf...."
        // }
      ],
    },
    /**
     * mOTP 정보 - 유효성 check 용도
     */
    checkMotp: {
      in: {
        operGroupCd: "", // 운영그룹코드
        cin: "", // 고객정보번호 (this.sessionInfo.userInfo.cno)
        wWWBnkgLginID: "", // 인터넷뱅킹로그인IDthis(sessionInfo.userInfo.userIdnfr)
      },
      out: {
        success: {
          operGroupCd: "", // 운영그룹코드
          iD: "", // mOTP ID
          otpStusDstcd: "", // OTP상태구분코드
          coprPpsnDstcd: "", // 법인개인구분코드
          cin: "", // 고객정보번호
          wWWBnkgLginID: "", // 인터넷뱅킹로그인ID
          mchtlUniqNo: "", // 기기고유번호
          pinFailNotms: 0, // 핀실패횟수
          certnErrNotms: 0, // 인증오류횟수
          smphMchtlUniqNo: "", // 스마트폰기기고유번호
          smphMchtlDstcd: "", // 스마트폰기기구분코드(1:IPhone, 2:안드로이드)
          pgmVsnno: "", // 프로그램버전번호
          certnDmndCd: "", // 인증요청코드(1:자동, 2:수동)
          smphMdelName: "", // 스마트폰모델명
        },
      },
    },
  };
};

const auth = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    /**
     * mOTP 모바일내 존재여부
     */
    getMotpExstYN: state => {
      return state.mOtpExstYN;
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    mut001_SSInfogetMotp: function (state, payload) {
      state.SSInfogetMotp.out = [];
      payload.Motpinfo.length > 0 &&
        payload.Motpinfo.forEach(e => {
          state.SSInfogetMotp.out.push(e);
        });
    },
  },
  actions: {
    actAllStateReset({ commit }) {
      commit("resetState");
      commit("userGuideMotp/resetState");
      commit("createMotp/resetState");
      commit("changeMotpPin/resetState");
      commit("authPCMotp/resetState");
      commit("certnStupModfiMotp/resetState");
      commit("discardOrReportMotp/resetState");
      commit("reregisterOtp/resetState");
      commit("createFido/resetState");
      commit("commMotpCertn/resetState");
      commit("unlockAuthErrMotp/resetState");
      commit("manageFido/resetState");
    },
    /**
     *
     *  Motp 원장조회 native - 로그인 후
     */
    act001_getNativeMotp: function () {
      this.state.auth.checkNativeMotp = false;
      this._vm.$bridge.SSInfogetMotp_mOtpExstYN();
      return new Promise(resolve => {
        callNative = setInterval(() => {
          if (this.state.auth.checkNativeMotp === true) {
            clearInterval(callNative);
            resolve("SUCCESS");
          }
        }, 5);
      });
    },
    /**
     * Motp 원장조회
     */
    act002_getMotpLedger: function () {
      this.state.auth.checkMotp.in.operGroupCd = this.state.sessionInfo.userInfo.operGroupCd;
      this.state.auth.checkMotp.in.cin = this.state.sessionInfo.userInfo.cno;
      this.state.auth.checkMotp.in.wWWBnkgLginID = this.state.sessionInfo.userInfo.userIdnfr;

      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/common/getMotpLedger",
          this.state.auth.checkMotp.in,
          response => {
            this._vm.$set(this.state.auth.checkMotp.out, "success", response);
            resolve("success");
          },
          response => {
            this._vm.$set(this.state.auth.checkMotp.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * 기기정보와 mOTP INFO 비교 검증
     */
    act003_checkMotpExstYN: async function (context) {
      //초기화
      Object.assign(context.state, getDefaultState());

      // 기기의 mOTP INFO 등록정보를 가져옴.
      await this.dispatch("auth/act001_getNativeMotp");

      // 서버의 mOTP INFO 등록정보를 가져옴.
      await this.dispatch("auth/act002_getMotpLedger");

      // 현재 폰에 정상인 mOTP가 있는 경우
      if (
        this.state.auth.SSInfogetMotp.out.filter(item => {
          return item.strUserId === this.state.auth.checkMotp.out.success.iD;
        }).length > 0 &&
        this.state.auth.checkMotp.out.success.otpStusDstcd === "030" &&
        this.state.auth.checkMotp.out.success.smphMchtlUniqNo === this.state.native.smphMchtlUniqNo
      ) {
        // console.log("[auth] OK---->현재 폰에 정상인 mOTP가 있는 경우 ");
        this.state.auth.mOtpExstYN = "Y";
      } else {
        // console.log("[auth] NO---->현재 폰에 비정상인 mOTP가 있는 경우");
        this.state.auth.mOtpExstYN = "N";
      }
    },
  },
  modules: {
    userGuideMotp,
    createMotp,
    changeMotpPin,
    authPCMotp,
    certnStupModfiMotp,
    discardOrReportMotp,
    reregisterOtp,
    createFido,
    commMotpCertn,
    unlockAuthErrMotp,
    manageFido,
  },
};

export default auth;
